import React, { useEffect, useRef, useState } from 'react';
import Routes from './routes';
import {useSelector, useDispatch} from 'react-redux'
import { URL } from './variables';
import { logout } from './actions/AppActions';
import { CandidateLoader } from './Home/CandidateUi';
import { getLanguageTexts, getSelectedLanguage } from './language';
import { isChromeBrowser, openCurrentLinkInChrome } from './utils/chromeOpen';

const EXTERNAL_CAMERA_TAB_LOCK_KEY = 'ontest_external_camera_active_tab';
const EXTERNAL_CAMERA_TAB_LOCK_TIMEOUT = 7000;


function App()  {
    const [loading,setLoading]=useState(true);
    const [blockedByOpenTab, setBlockedByOpenTab] = useState(false);
    const t = getLanguageTexts(getSelectedLanguage());
    const dispatch=useDispatch();
    
    
    const intervalRef = useRef();
    const tabLockIntervalRef = useRef();
    const tabIdRef = useRef(`${Date.now()}-${Math.random().toString(36).slice(2)}`);
    const showChromePrompt = !isChromeBrowser();
    const chromePrompt = showChromePrompt ? (
        <div className="external-camera-chrome-prompt" role="alert">
            <div>
                <strong>{t.open_in_chrome_title}</strong>
                <span>{t.open_in_chrome_hint}</span>
            </div>
            <button type="button" className="btn btn-primary" onClick={openCurrentLinkInChrome}>
                <i className="mdi mdi-google-chrome"></i> {t.open_in_chrome}
            </button>
        </div>
    ) : null;

    const wake = async()=>{
        try{
            const wakeLock = await navigator.wakeLock.request('screen');
        }
        catch(e){
            console.log('error',e);
        }
    }


    const get_token = (id_url)=>{
        fetch(`${URL}api/integration/auth/validate_token`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body:JSON.stringify({
                id_url:id_url,
                system:'external_camera'
            })
        }).then(async(response)=>{
            let resp = await response.json();
            if(resp.message == 'Server Error'){
                setTimeout(()=>{
                    get_token(id_url)
                },5000);
                return;
            }
            else if(resp.status==true){
                localStorage.setItem('token',resp.token)
                dispatch({type:'login',payload:{token:resp.token,user:{}}});

            }
            else{
                
                dispatch(logout())
                // window?.history?.back();

            }
            setLoading(false);
        }).catch((e)=>{
            setTimeout(()=>{
                get_token(id_url)
            },5000);
        })
    }
    useEffect(()=>{
        localStorage.setItem('external_camera_theme', 'light');
        document.body.classList.remove('external-camera-dark-theme');

        const readActiveTab = () => {
            try {
                return JSON.parse(localStorage.getItem(EXTERNAL_CAMERA_TAB_LOCK_KEY));
            } catch (e) {
                return null;
            }
        };

        const releaseTabLock = () => {
            const activeTab = readActiveTab();
            if (activeTab != null && activeTab.id === tabIdRef.current) {
                localStorage.removeItem(EXTERNAL_CAMERA_TAB_LOCK_KEY);
            }
        };

        const updateTabLock = () => {
            const now = Date.now();
            const activeTab = readActiveTab();
            if (activeTab != null && activeTab.id !== tabIdRef.current && now - activeTab.updatedAt < EXTERNAL_CAMERA_TAB_LOCK_TIMEOUT) {
                setBlockedByOpenTab(true);
                return false;
            }

            localStorage.setItem(EXTERNAL_CAMERA_TAB_LOCK_KEY, JSON.stringify({
                id: tabIdRef.current,
                updatedAt: now
            }));
            setBlockedByOpenTab(false);
            return true;
        };

        const handleStorage = (event) => {
            if (event.key === EXTERNAL_CAMERA_TAB_LOCK_KEY) {
                updateTabLock();
            }
        };

        const canUseTab = updateTabLock();
        tabLockIntervalRef.current = setInterval(updateTabLock, 2000);
        window.addEventListener('storage', handleStorage);
        window.addEventListener('beforeunload', releaseTabLock);

        if (!canUseTab) {
            setLoading(false);
            return ()=>{
                clearInterval(tabLockIntervalRef.current)
                window.removeEventListener('storage', handleStorage);
                window.removeEventListener('beforeunload', releaseTabLock);
            }
        }

        intervalRef.current = setInterval(()=>{
            document.getElementsByTagName('html')[0].childNodes.forEach((elem)=>{
                if(elem.nodeName!='BODY' && elem.nodeName!='HEAD' && elem.nodeName!='TEXT'){
                    elem.remove();
                }
            })
        },1000);


        const params = new URLSearchParams(window.location.search) // id=123
        let token = params.get('token') // 123 
        console.log(token)
        if(token==null){
            token = localStorage.getItem('token');
            dispatch({type:'login',payload:{token:token,user:{}}});
            setLoading(false);

        }
        else{
            get_token(token)
        }

        wake();

        return ()=>{
            clearInterval(intervalRef.current)
            clearInterval(tabLockIntervalRef.current)
            window.removeEventListener('storage', handleStorage);
            window.removeEventListener('beforeunload', releaseTabLock);
            releaseTabLock();
        }
    },[])

    if (blockedByOpenTab) {
        return (
            <>
                {chromePrompt}
                <div className="candidate-auth-loading">
                    <div className="external-camera-single-session-card">
                        <div className="external-camera-single-session-icon">
                            <i className="mdi mdi-cellphone-lock"></i>
                        </div>
                        <h1>{t.external_camera_session_active_title}</h1>
                        <p>{t.external_camera_session_active_hint}</p>
                        <button type="button" className="btn btn-primary" onClick={() => window.location.reload()}>
                            <i className="mdi mdi-refresh"></i> {t.reload_page}
                        </button>
                    </div>
                </div>
            </>
        );
    }

    return (
        <>
            {chromePrompt}
            {loading == false ? <Routes /> : (
                <div className="candidate-auth-loading">
                    <CandidateLoader title={t.loading_data} description={t.external_camera_loading_hint} />
                </div>
            )}
        </>
    );
}

export default App;
